import React, { Fragment, useCallback, useEffect, useState } from "react";
import classNames from "classnames/bind";
import image from "../../../../assets/images/NoConnect.png";
import imageEn from "../../../../assets/images/NoConnect-en.png";
import styles from "./ModalLive.module.css";
import ReactPlayer from "react-player";
import axiosClient from "../../../../services/axiosClient";
import streamingClient from "../../../../services/streamingClient";
import { OnStatusGreen, WeakConnectStatus } from "../../../../components/Icons/Icons";
import { Clock, HeaderModal, Pagination, Toast } from "../../../../components";
import RenderStatus from "../../../../components/StatusRender";

const cx = classNames.bind(styles);
const ModalLive = ({ onClose, code_cam }) => {
  const [stream, setStream] = useState([]);
  const companyCode = sessionStorage.getItem('company_code');

  useEffect(() => {
    const getPath = async () => {
      const res2 = await streamingClient.post(
        "/streamManagement/post-list-path-streaming/",
        {
          list_camera: {
            data: [
              {
                camera_code: code_cam
              }
            ],
          },
        }
      );
      setStream(res2.stream);
    };
    getPath();
  }, [code_cam]);

  return (
    <div className={cx("container")}>
      <div id="__notification"></div>
      <div className={cx("content")}>
        <HeaderModal onClose={onClose} title={"Xem trực tiếp"} />
        <div className={cx("data")}>
          {stream.map((item, index) => {
            return (
              <div className={cx("stream")} key={index}>
                {item?.data[0].PATH !== "no-path" ? (
                  <ReactPlayer
                    className="react-player"
                    url={`${process.env.REACT_APP_BASE_URL}livestream${item?.data[0].PATH}`}
                    width={"100%"}
                    height={"100%"}
                    playing
                  />
                ) : (
                  <img
                    src={localStorage?.getItem("laguage") === 'en' ? imageEn : image}
                    alt={"sub"}
                    style={{
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
                <div className={cx("setting")}>
                  <div className={cx("name_status")}>
                    <span className={cx("On")}>
                      <RenderStatus companyCode={companyCode} status={item?.data[0].PATH === "no-path" ? 2 : item?.status_active} />
                    </span>
                    <span
                      style={{ fontSize: 12, maxWidth: "100%" }}
                      className={cx("name")}
                    >
                      {item?.name}
                    </span>
                  </div>
                  {item.is_AI && (
                    <div className={cx("icon-ai")}>
                      <div className={cx("ai")}>AI</div>
                    </div>
                  )}
                  <div className={cx("footer")}>
                    <div className={cx("icon")} style={{ width: "100%" }}>
                      <Clock />
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        {/* <div className={cx("pagination")}>
          {stream?.length > 0 && (
            <Pagination
              onClick={(data) => setCurrentPage(data)}
              onNext={() => setCurrentPage(currentPage + 1)}
              onPrevious={() => setCurrentPage(currentPage - 1)}
              currentPage={currentPage}
              pages={stream.length}
            />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default ModalLive;
